import React from 'react';

export const Privacy: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 pb-20 pt-32">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl border border-slate-200 shadow-card p-8 md:p-12">
          <h1 className="font-display text-4xl font-bold text-ink-800 mb-4">Privacy Policy</h1>
          <div className="w-20 h-0.5 bg-gradient-to-r from-primary-600 to-accent-500 mb-8"></div>
          <p className="text-gray-500 text-sm mb-8">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Information We Collect</h2>
              <p className="text-gray-600 leading-relaxed">
                We collect information you provide directly to us, such as when you create an account, 
                fill out a form, or communicate with us. This may include your name, email address, 
                phone number, and company details.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">2. How We Use Your Information</h2>
              <p className="text-gray-600 leading-relaxed">
                We use the information we collect to provide, maintain, and improve our services, 
                to communicate with you, and to comply with legal obligations.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Data Security</h2>
              <p className="text-gray-600 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your 
                personal information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Cookies</h2>
              <p className="text-gray-600 leading-relaxed">
                We use cookies to enhance your experience on our website. You can set your browser 
                to refuse all or some browser cookies, but this may affect the functionality of our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Third-Party Services</h2>
              <p className="text-gray-600 leading-relaxed">
                We may share your information with third-party service providers who perform services 
                on our behalf, such as payment processing, data analysis, and email delivery.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Your Rights</h2>
              <p className="text-gray-600 leading-relaxed">
                You have the right to access, correct, or delete your personal information. 
                Contact us at team.buildflow@gmail.com for any privacy-related requests.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Contact Us</h2>
              <p className="text-gray-600 leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at:<br />
                Email: team.buildflow@gmail.com <br />
                
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};